// extracted by mini-css-extract-plugin
export default {"mainContainer":"Index_mainContainer__+8JKk","pageContent":"Index_pageContent__gY-eN","sidebar":"Index_sidebar__6gZ5P","backLink":"Index_backLink__A5hX0"};